<app-sub-nav title="Devices" i18n-title="@@companyDevices" queryParamKey="devicesTab">
	<ng-template
		appSubNavTab
		label="All Devices"
		i18n-label="@@deviceMainTab-allLabel"
		automationId="company-all-devices-tab"
	>
		<app-all-devices
			[companyId]="companyId"
			[company]="company"
			[canWrite]="canWrite"
			[deviceDataRequest]="deviceDataRequest"
			[appBreadcrumbLabel]="breadcrumbLabel"
		></app-all-devices>
	</ng-template>

	<ng-template
		appSubNavTab
		label="Device Groups"
		i18n-label="@@deviceMainTab-groupsLabel"
		automationId="company-device-groups-tab"
	>
		<app-device-groups
			[companyId]="companyId"
			[canWrite]="canWrite"
			[appBreadcrumbLabel]="breadcrumbLabel"
		></app-device-groups>
	</ng-template>
</app-sub-nav>
